import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IonCol, IonGrid, IonRow } from '@ionic/angular/standalone';
import { SharedModule } from '../../shared.module';
import { BUTTON_TYPES } from '../components/modal-frame/modal-frame.constants';
import { CONSTS } from './do-not-process.constants';

@Component({
  selector: 'app-do-not-process',
  imports: [SharedModule, IonRow, IonCol, IonGrid],
  templateUrl: './do-not-process.component.html',
  styleUrl: './do-not-process.component.scss',
})
export class DoNotProcessComponent {
  readonly dialogRef = inject<{ trackingNumberList: string[] }>(
    MAT_DIALOG_DATA,
  );

  readonly dialog: MatDialogRef<DoNotProcessComponent> = inject(
    MatDialogRef<DoNotProcessComponent>,
  );

  readonly CONSTS = CONSTS;
  readonly BUTTON_TYPES = BUTTON_TYPES;

  onClose() {
    this.dialog.close();
  }
}
